import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

const Skeleton = ({ className }) => (
  <div
    className={twMerge(
      'animate-pulse cursor-wait bg-neutral-high-300 dark:bg-neutral-low-200',
      className
    )}
    data-test-selector="skeleton"
  />
);

Skeleton.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default Skeleton;
